import { render, staticRenderFns } from "./garch.vue?vue&type=template&id=6a805efb&"
import script from "./garch.vue?vue&type=script&lang=js&"
export * from "./garch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports